import {
  Form,
  Input,
  Modal,
  Select,
  Space,
  Button,
  Tooltip,
  message,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef
} from "react";
import {
  MailOutlined,
  CheckOutlined,
  CloseOutlined,
  HomeOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import PDFModal from "@/views/AccountPayable/ApprovalSummary/component/PDFModal"
import { useLocation } from 'react-router-dom';
import { CustomTable, CustomTableExtend, CustomUpload } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import InsuranceVPH from "@/views/AccountPayable/ApprovalSummary/component/InsuranceVPH";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [openApproval, setOpenApproval] = useState(false);
  const [filedModalFlag, setFiledModalFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [detailRecord, setDetailRecord] = useState({});
  const [approvedOrRejected, setApprovedOrRejected] = useState('Approved');
  const [approvalForm,] = Form.useForm();
  const [selectedList, setSelectedList] = useState([]);
  
  const [currentRecord, setCurrentRecord] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const PDFModalRef = useRef();
  const InsuranceVPHRef = useRef();

  const initTableHead = {
    amount: null,
    materialRemark: null,
    jobs: null,
    glAcct: null,
    invoiceDateAp: null,
    storeName: null,
    unitAddress: null,
    requestNo: null,
    supervisor: null,
    vendorType: null,
    vendorName: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#',
    // },
    {
      title: 'Pay Amount',
      dataIndex: "amount",
      titleType: '',
      width:100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'amount'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => handleAmountClick(record)}
            className="CA-AS-AmountStyle"
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(text)}
          </span>
        );
      },
    },
    {
      title: 'Prop - Address',
      dataIndex: "propName",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'propName'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => InsuranceVPHRef?.current?.setModalOpen({record})}
            style={{
              color: "#1890ff",
              // textDecoration: "underline dashed",
              cursor: "pointer",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "GL / Insure",
      dataIndex: "glAcct",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Deductible',
      dataIndex: "liabilityDeductible",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'liabilityDeductible')
    },
    {
      title: 'Limits',
      dataIndex: "liabilityLimit",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'liabilityLimit')
    },
    {
      title: 'Expiration - Effective Date',
      dataIndex: "expirationDate",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => (
        `${record.expirationDate} / ${record.effectiveDate}`
      ),
      // onChange: e => tableFilterFn(e, 'expirationDate'),
    },
    {
      title: 'Policy Number',
      dataIndex: "policyNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'policyNumber')
    },
    {
      title: 'Carrier',
      dataIndex: "carrier",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'carrier')
    },
    {
      title: 'Agent',
      dataIndex: "agent",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'agent')
    },
    {
      title: 'Payee',
      dataIndex: "payee",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'payee')
    },
    {
      title: 'Requested Date',
      dataIndex: "cdate",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'requestedByName')
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const searchParams = getPropsParamsFn()
    const params = {
      page: current || pagination.current ,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      usid: searchParams.email,
      type: searchParams.module,
      batch: searchParams.batch,
      storeName: searchParams.storeName,
    };
    const response = await http.get(api.CAInsurance, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    // setSelectedList([])
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }))
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const handleAmountClick = (record) => {
    setCurrentRecord(record);
    PDFModalRef?.current?.setModalOpen(true);
  };

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])
  
  // 提交数据
  const handleSubmit = async () => {
    setBtnLoading(true)
    const values = await approvalForm.validateFields();
    // 合并数据：表格选中的数据 + 表单数据
    const data = {
      ...values,
      ids: selectedList.map(item => item.vendorPaymentId),
      approvedOrRejected,
      batchGroup: getPropsParamsFn().batch,
      // usid: selectedList.map(item => item.usid)
    };
    const response = await http.post(api.getCheckApprovalApprove, data);
    if(response.code === '1'){
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setRefreshKey(+new Date())
    }else{
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false)
  };
 
  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: '1',
      noLimit: 'no'
    });
  };

  const getPropsParamsFn = () => {
    const searchParams = new URLSearchParams(location.search);
 
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
      >
        <div className="topLeft">
          <Space size="small">
            {commonFn.btnAuthorityFlag('Approval') && <Tooltip
              placement="topLeft"
              title="Approval The Requests For Approval From Employee"
            >
              <Button className="btnGreen" style={{marginRight: 0}} onClick={() => approveOrRejectFn('Approved')}>
                <CheckOutlined />
                Approval
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('Reject') && <Tooltip
              placement="topLeft"
              title="Reject The Requests For Approval From Employee"
            >
              <Button className="btnWarning" style={{marginLeft: 0}} onClick={() => approveOrRejectFn('rejected')}>
               <CloseOutlined />
                Reject
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('SelectedAmount') && <Button className="btnGreen" style={{cursor: 'text'}}>Selected Amount:{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(selectedList.map(item => item.amount).reduce((acc, curr) => acc + curr, 0))
            }</Button> || null}
          </Space>
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openApproval}
        maskClosable={false}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to approve these checks?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${approvedOrRejected === 'Approved' ? 'Approve' : 'Reject'} ${selectedList.length} Check(s).`,
                }
              ]}
            />
          </Form.Item>

          {approvedOrRejected === 'Approved' && <Form.Item
            name="noLimit"
            label={<span >Do you want to approve the amount over {<span style={{color:'#a94442',textDecoration:'underline'}}>
              {
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(5000)
              }
            </span>} with signature</span>}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "no",
                  label: "No",
                },
                {
                  value: "yes",
                  label: "Yes",
                },
              ]}
            />
          </Form.Item> || null}

          {approvedOrRejected !== 'Approved' && <Form.Item
            name="rejectedReason"
            label="Rejected Reason"
            style={{ flex: 2 }}
          >
            <Input placeholder="" />
          </Form.Item> || null}
        </Form>
      </Modal>
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            File
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={filedModalFlag}
        onCancel={() => setFiledModalFlag(false)}
        footer={null}
        maskClosable={false}
        // destroyOnClose={true}
        width="80%"
      >
      <div
        key={detailRecord?.vendorPaymentId}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <CustomUpload
          setFilePaths={setFilePaths} 
          filePaths={filePaths} 
          setBtnDisabled={setBtnDisabled}
          btnDisabled={btnDisabled}
          isEdit={true}
          vendorPaymentId={detailRecord?.vendorPaymentId || undefined}
          foreignId={detailRecord?.vendorPaymentId || undefined}
          preCalFile={detailRecord?.preCalFile || undefined}
          type={detailRecord?.type || undefined}
          customConfig={{
            pdfHeight: '62vh',
            noShowUpload: true,
            noSubmitBtn: true,
            pageName: 'CheckApproval'
          }}
        />
        <div style={{textAlign: 'center', marginTop: 20}}>
          <Button onClick={() => setFiledModalFlag(false)}>
            cancel
          </Button>
        </div>
      </div>
      </Modal>

      <PDFModal ref={PDFModalRef} record={currentRecord} />

      <InsuranceVPH ref={InsuranceVPHRef} amountUrl={api.CAInsuranceAmount} />

    </div>
  );
});
export default MainTable;
